import { FleekError } from './FleekError';

type FleekFunctionBundlingFailedErrorOptions = {
  error: string;
};

export class FleekFunctionBundlingFailedError extends FleekError<FleekFunctionBundlingFailedErrorOptions> {
  public name = 'FleekFunctionBundlingFailedError';

  toString = () => {
    return `Bundle creation failed. For information on supported packages, please consult our documentation.\nError: ${this.data.error}`;
  };
}
